import { Access } from '../../enums';
import { Permission } from '../permission';

const CARE_KEY = 'care';
export const CARE = {
  READ: new Permission({
    key: `${CARE_KEY}:${Access.READ}`,
    description: 'Pflegedoku Übersicht Leserecht',
  }),

  WRITE: new Permission({
    key: `${CARE_KEY}:${Access.WRITE}`,
    description: 'Pflegedoku Übersicht Schreibrecht',
  }),

  DELETE: new Permission({
    key: `${CARE_KEY}:${Access.DELETE}`,
    description: 'Pflege - Löschrecht',
  }),

  ABSENCE: new Permission({
    key: `${CARE_KEY}:absence:${Access.WRITE}`,
    description: 'Abwesenheit Schreibrecht',
  }),

  ASSESSMENT: {
    READ: new Permission({
      key: `${CARE_KEY}:assessment:${Access.READ}`,
      description: 'Begutachtung - Leserecht',
    }),

    WRITE: new Permission({
      key: `${CARE_KEY}:assessment:${Access.WRITE}`,
      description: 'Begutachtung - Schreibrecht',
    }),
  },

  CONSULTATION_FORM: {
    READ: new Permission({
      key: `${CARE_KEY}:consultation-form:${Access.READ}`,
      description: 'Beratungsbogen - Leserecht',
    }),

    WRITE: new Permission({
      key: `${CARE_KEY}:consultation-form:${Access.WRITE}`,
      description: 'Beratungsbogen - Schreibrecht',
    }),
  },

  MOVEMENT_STATUS: {
    READ: new Permission({
      key: `${CARE_KEY}:movement-status:${Access.READ}`,
      description: 'Bewegungsstatus - Leserecht',
    }),

    WRITE: new Permission({
      key: `${CARE_KEY}:movement-status:${Access.WRITE}`,
      description: 'Bewegungsstatus - Schreibrecht',
    }),
  },

  BIOGRAPHY: {
    READ: new Permission({
      key: `${CARE_KEY}:biography:${Access.READ}`,
      description: 'Biographie - Leserecht',
    }),

    WRITE: new Permission({
      key: `${CARE_KEY}:biography:${Access.WRITE}`,
      description: 'Biographie - Schreibrecht',
    }),
  },

  NURSE_VISIT: {
    READ: new Permission({
      key: `${CARE_KEY}:nurse-visit:${Access.READ}`,
      description: 'Pflegevisite - Leserecht',
    }),

    WRITE: new Permission({
      key: `${CARE_KEY}:nurse-visit:${Access.WRITE}`,
      description: 'Pflegevisite - Schreibrecht',
    }),
  },

  PFLEGEGRAD_ASSESSMENT: {
    READ: new Permission({
      key: `${CARE_KEY}:pflegegrad-assessment:${Access.READ}`,
      description: 'Pflegegrad Einstufung - Leserecht',
    }),

    WRITE: new Permission({
      key: `${CARE_KEY}:pflegegrad-assessment:${Access.WRITE}`,
      description: 'Pflegegrad Einstufung - Schreibrecht',
    }),
  },

  REPORT: {
    READ: new Permission({
      key: `${CARE_KEY}:report:${Access.READ}`,
      description: 'Report - Leserecht',
    }),
  },

  DATA_COLLECTION: {
    READ: new Permission({
      key: `${CARE_KEY}:data-collection:${Access.READ}`,
      description: 'Datenerhebung - Leserecht',
    }),

    WRITE: new Permission({
      key: `${CARE_KEY}:data-collection:${Access.WRITE}`,
      description: 'Datenerhebung - Schreibrecht',
    }),
  },

  DECUBITUS_RISK: {
    READ: new Permission({
      key: `${CARE_KEY}:decubitus-risk:${Access.READ}`,
      description: 'Dekubitusrisiko - Leserecht',
    }),

    WRITE: new Permission({
      key: `${CARE_KEY}:decubitus-risk:${Access.WRITE}`,
      description: 'Dekubitusrisiko - Schreibrecht',
    }),
  },

  EXECUTION: {
    READ: new Permission({
      key: `${CARE_KEY}:execution:${Access.READ}`,
      description: 'Durchführung - Leserecht',
    }),

    WRITE: new Permission({
      key: `${CARE_KEY}:execution:${Access.WRITE}`,
      description: 'Durchführung - Schreibrecht',
    }),
  },

  EXECUTION_EXTENDED: {
    WRITE: new Permission({
      key: `${CARE_KEY}:execution-extended:${Access.WRITE}`,
      description: 'Durchführung - Schreibrecht (erweitert)',
    }),
  },

  NUTRITION_PROTOCOL: {
    READ: new Permission({
      key: `${CARE_KEY}:nutrition-protocol:${Access.READ}`,
      description: 'Ernährungsprotokoll - Leserecht',
    }),

    WRITE: new Permission({
      key: `${CARE_KEY}:nutrition-protocol:${Access.WRITE}`,
      description: 'Ernährungsprotokoll - Schreibrecht',
    }),
  },

  // Fallbesprechung L
  // Fallbesprechung S
  CASE_DISCUSSION: {
    READ: new Permission({
      key: `${CARE_KEY}:case-discussion:${Access.READ}`,
      description: 'Fallbesprechung - Leserecht',
    }),

    WRITE: new Permission({
      key: `${CARE_KEY}:case-discussion:${Access.WRITE}`,
      description: 'Fallbesprechung - Schreibrecht',
    }),
  },

  INDICATORS: {
    READ: new Permission({
      key: `${CARE_KEY}:indicators:${Access.READ}`,
      description: 'Indikatoren - Leserecht',
    }),

    WRITE: new Permission({
      key: `${CARE_KEY}:indicators:${Access.WRITE}`,
      description: 'Indikatoren - Schreibrecht',
    }),
  },

  MEDICATION_ORDER: {
    READ: new Permission({
      key: `${CARE_KEY}:medication-order:${Access.READ}`,
      description: 'Med Bestellung - Leserecht',
    }),

    WRITE: new Permission({
      key: `${CARE_KEY}:medication-order:${Access.WRITE}`,
      description: 'Med Bestellung - Schreibrecht',
    }),
  },

  MEDICATION: {
    READ: new Permission({
      key: `${CARE_KEY}:medication:${Access.READ}`,
      description: 'Medikamente - Leserecht',
    }),

    WRITE: new Permission({
      key: `${CARE_KEY}:medication:${Access.WRITE}`,
      description: 'Medikamente - Schreibrecht',
    }),
  },

  TASKS: {
    READ: new Permission({
      key: `${CARE_KEY}:nursing-tasks:${Access.READ}`,
      description: 'Pflegeaufgaben - Leserecht',
    }),

    WRITE: new Permission({
      key: `${CARE_KEY}:nursing-tasks:${Access.WRITE}`,
      description: 'Pflegeaufgaben - Schreibrecht',
    }),
  },

  TASKS_EXTENDED: {
    WRITE: new Permission({
      key: `${CARE_KEY}:nursing-tasks-extended:${Access.WRITE}`,
      description: 'Pflegeaufgaben - Schreibrecht (erweitert)',
    }),
  },

  NURSING_REPORT: {
    READ: new Permission({
      key: `${CARE_KEY}:care-report:${Access.READ}`,
      description: 'Pflegebericht - Leserecht',
    }),

    WRITE: new Permission({
      key: `${CARE_KEY}:care-report:${Access.WRITE}`,
      description: 'Pflegebericht - Schreibrecht',
    }),
  },

  CARE_PLAN_SUPERVISOR: new Permission({
    key: `${CARE_KEY}:care-plan-supervisor:${Access.WRITE}`,
    description: 'Pflegeplan Betr. - Schreibrecht',
  }),

  CARE_PLAN: {
    READ: new Permission({
      key: `${CARE_KEY}:care-plan:${Access.READ}`,
      description: 'Pflegeplan - Leserecht',
    }),

    WRITE: new Permission({
      key: `${CARE_KEY}:care-plan:${Access.WRITE}`,
      description: 'Pflegeplan - Schreibrecht',
    }),
  },

  CARE_ROUNDS: {
    READ: new Permission({
      key: `${CARE_KEY}:care-rounds:${Access.READ}`,
      description: 'Pflegevisite - Leserecht',
    }),

    WRITE: new Permission({
      key: `${CARE_KEY}:care-rounds:${Access.WRITE}`,
      description: 'Pflegevisite - Schreibrecht',
    }),
  },

  PAIN_PROTOCOL: {
    READ: new Permission({
      key: `${CARE_KEY}:pain-protocol:${Access.READ}`,
      description: 'Schmerzprotokoll - Leserecht',
    }),

    WRITE: new Permission({
      key: `${CARE_KEY}:pain-protocol:${Access.WRITE}`,
      description: 'Schmerzprotokoll - Schreibrecht',
    }),
  },

  SOCIAL_CARE: {
    READ: new Permission({
      key: `${CARE_KEY}:social-care:${Access.READ}`,
      description: 'Soziale Betreuung - Leserecht',
    }),

    WRITE: new Permission({
      key: `${CARE_KEY}:social-care:${Access.WRITE}`,
      description: 'Soziale Betreuung - Schreibrecht',
    }),
  },

  SOCIAL_CARE_GROUP: new Permission({
    key: `${CARE_KEY}:care-group:${Access.WRITE}`,
    description: 'Betreuungsgruppen',
  }),

  FALL_PROTOCOL: {
    READ: new Permission({
      key: `${CARE_KEY}:fall-protocol:${Access.READ}`,
      description: 'Sturzprotokoll - Leserecht',
    }),

    WRITE: new Permission({
      key: `${CARE_KEY}:fall-protocol:${Access.WRITE}`,
      description: 'Sturzprotokoll - Schreibrecht',
    }),
  },

  FALL_RISK: {
    READ: new Permission({
      key: `${CARE_KEY}:fall-risk:${Access.READ}`,
      description: 'Sturzrisiko - Leserecht',
    }),

    WRITE: new Permission({
      key: `${CARE_KEY}:fall-risk:${Access.WRITE}`,
      description: 'Sturzrisiko - Schreibrecht',
    }),
  },

  VISIT_SHEET: {
    READ: new Permission({
      key: `${CARE_KEY}:visit-sheet:${Access.READ}`,
      description: 'Visit-sheet - Leserecht',
    }),

    WRITE: new Permission({
      key: `${CARE_KEY}:visit-sheet:${Access.WRITE}`,
      description: 'Visit-sheet - Schreibrecht',
    }),
  },

  VITAL_SIGNS: {
    READ: new Permission({
      key: `${CARE_KEY}:vital-signs:${Access.READ}`,
      description: 'Vitalzeichen - Leserecht',
    }),

    WRITE: new Permission({
      key: `${CARE_KEY}:vital-signs:${Access.WRITE}`,
      description: 'Vitalzeichen - Schreibrecht',
    }),
  },

  VITAL_INFORMATIONS: {
    READ: new Permission({
      key: `${CARE_KEY}:vital-informations:${Access.READ}`,
      description: 'Vitale Informationen - Leserecht',
    }),

    WRITE: new Permission({
      key: `${CARE_KEY}:vital-informations:${Access.WRITE}`,
      description: 'Vitale Informationen - Schreibrecht',
    }),
  },

  DOCTORS_DIAGNOSIS: {
    READ: new Permission({
      key: `${CARE_KEY}:doctors-diagnosis:${Access.READ}`,
      description: 'Ärzte / Diagnosen- Leserecht',
    }),

    WRITE: new Permission({
      key: `${CARE_KEY}:doctors-diagnosis:${Access.WRITE}`,
      description: 'Ärzte / Diagnosen - Schreibrecht',
    }),
  },

  WOUND_DOCUMENTATION: {
    READ: new Permission({
      key: `${CARE_KEY}:wound-documentation:${Access.READ}`,
      description: 'Wunddoku - Leserecht',
    }),

    WRITE: new Permission({
      key: `${CARE_KEY}:wound-documentation:${Access.WRITE}`,
      description: 'Wunddoku - Schreibrecht',
    }),
  },

  GENERAL_ORDER: {
    DELETE: new Permission({
      key: `${CARE_KEY}:general-order:${Access.DELETE}`,
      description: 'Allgemeine Bestellung - Löschen',
    }),

    WRITE: new Permission({
      key: `${CARE_KEY}:general-order:${Access.WRITE}`,
      description: 'Allgemeine Bestellung - Schreibrecht',
    }),
  },
};
